import axios from '../../axios';

export default async function purchaseNowRequest(tempId: string): Promise<void> {
  const response = await axios.post<void>(
    `${process.env.REACT_APP_CATALOG_BASE_URL}/purchases/transaction`,
    {
      tempId
    }
  );
  return response.data;
}
